module.exports = __webpack_public_path__ + "static/media/0024_IMG_TRAD_LE_SOL_CARRELAGE_EXISTANT.47fa3868.webp";